module.exports = __webpack_public_path__ + "img/light-logo.d5f610ec.svg";